

import { useAuthStore } from "../store/authstore";
import { useBonusPopupStore } from "../store/coinstore";
import deviceInfo from "./deviceInfo";
import tohash from "./tohash";
import { updateServerTime, formatToMySQLDateTime, getCurrentServerTime } from "./serverTime";


export async function fetchCoinData(userId: string, userEmail: string = ''): Promise<any> {
  const device = deviceInfo()
  const device_id = tohash(`${device.name}${device.platform}${device.os}${userEmail}${device.version}`)
  const showBonusPopup = useBonusPopupStore.getState().show;
  const url = 'https://dramasstory.com/web/get_user_coin.php';

  return await fetch(`${url}?user_id=${userId}&device_id=${device_id}`)
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      // console.log('fetch coin data:', data)
      // Update server time on every API call
      if (data.data.currenttime) {
        updateServerTime(data.data.currenttime);
      }
      if (data.data.data.length === 0 || data.data.data.welcome_bonus === "0") {
              // Update server time from response
              if (data.data.mobile_dt) {
                updateServerTime(data.data.mobile_dt);
              }
        showBonusPopup();
        return null;
      } else {
        return data.data.data;
      }
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
      throw error;
    });
}




export async function addCoinData(data: Record<string, any>, userType: string): Promise<any> {
  const user = useAuthStore.getState().user;
  const fcm = localStorage.getItem('fcm_token') || '';
  const device = deviceInfo();
  const deviceId = tohash(`${device.name}${device.platform}${device.os}${user?.user_email}${device.version}`);
  const defaultData = {
    type: data.type || "sub",
    user_id: user?.user_id || "0",
    device_id: deviceId?.toString() || "",
    a_id: 0,
    cc: "US",
    fcm: fcm,
  }

  const firstUserData = {
    ...defaultData,
    mobile_dt: "0",
    coins: data.coins,
    day_streak: "0",
    turn_on_web_notification: "0",
    bind_email: "0",
    subscribe_youtube: "0",
    follow_instagram: "0",
    follow_facebook: "0",
    episode_ids: "0",
    share_with_friends: "0",
    expiry_day_streak: "0",
    welcome_bonus: data.welcome_bonus,
    is10: "0",
    is20: "0",
  }

  const streakData = {
    ...defaultData,
    mobile_dt: data.mobile_dt || "0",
    coins: data.coins,
    day_streak: data.day_streak || "0",
  }

  const streakExpiryData = {
    ...defaultData,
    mobile_dt: data.mobile_dt || "0",
    expiry_day_streak: "1",
    day_streak: "0",
  }

  const rewardData = { ...defaultData, ...data };

  const getFinalObj = () => {
    if (userType === "firstUser") {
      const sst = localStorage.getItem('_sst');
      sst ? firstUserData.mobile_dt = sst : firstUserData.mobile_dt = formatToMySQLDateTime(getCurrentServerTime());
      return firstUserData;

    } else if (userType === "streak") {
      // Ensure mobile_dt is in MySQL format (YYYY-MM-DD HH:MM:SS)
      if (streakData.mobile_dt && streakData.mobile_dt !== "0") {
        try {
          const dt = new Date(streakData.mobile_dt);
          streakData.mobile_dt = formatToMySQLDateTime(dt);
        } catch {
          streakData.mobile_dt = formatToMySQLDateTime(getCurrentServerTime());
        }
      }
      return streakData;
    } else if (userType === "streakExpiry") {
      // Ensure mobile_dt is in MySQL format
      if (streakExpiryData.mobile_dt && streakExpiryData.mobile_dt !== "0") {
        try {
          const dt = new Date(streakExpiryData.mobile_dt);
          streakExpiryData.mobile_dt = formatToMySQLDateTime(dt);
        } catch {
          streakExpiryData.mobile_dt = formatToMySQLDateTime(getCurrentServerTime());
        }
      }
      return streakExpiryData;
    } else {
      return rewardData;
    }
  }

  // console.log('addCoinData', getFinalObj());

  const url = 'https://dramasstory.com/web/drama_coin_data.php';

  return await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(getFinalObj()),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then((data) => {
      // Update server time on every coin API call (source of truth)
      if (data.data?.currenttime) {
        updateServerTime(data.data.currenttime);
      } else if (data.data?.mobile_dt) {
        updateServerTime(data.data.mobile_dt);
      }
      return data.data;
    })
    .catch((error) => {
      console.error('There was a problem with the fetch operation:', error);
      throw error;
    });
}